/* eslint-disable no-tabs */
import { COMPANY_PROFILE_DEFAULT } from 'components/icons/constants';
import PropTypes from 'prop-types';

const RatingIcon = ({
    color = COMPANY_PROFILE_DEFAULT.color,
    size = COMPANY_PROFILE_DEFAULT.size
}) => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={size}
        height={size}
        viewBox="0 0 70.865 70.867"
        enableBackground="new 0 0 70.865 70.867"
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M65.655,22.666c-1.651-3.906-4.016-7.416-7.029-10.428c-3.013-3.01-6.519-5.375-10.425-7.025
		c-4.045-1.711-8.343-2.578-12.769-2.578c-4.427,0-8.723,0.867-12.767,2.578c-3.906,1.65-7.414,4.016-10.427,7.025
		C9.228,15.25,6.863,18.76,5.21,22.666c-1.71,4.043-2.577,8.34-2.577,12.768S3.5,44.158,5.21,48.201
		c1.653,3.906,4.018,7.416,7.029,10.426c3.013,3.01,6.521,5.379,10.427,7.027c4.044,1.711,8.34,2.58,12.767,2.58
		c4.426,0,8.724-0.869,12.769-2.58c3.906-1.648,7.412-4.018,10.425-7.027c3.014-3.01,5.378-6.52,7.029-10.426
		c1.712-4.043,2.578-8.34,2.578-12.768S67.367,26.709,65.655,22.666z M35.433,66.291c-17.013,0-30.856-13.846-30.856-30.857
		c0-17.014,13.844-30.857,30.856-30.857c17.015,0,30.856,13.844,30.856,30.857C66.289,52.445,52.447,66.291,35.433,66.291z"
            />
            <path
                fill={color}
                d="M52.244,28.965l-11.015-1.6l-4.924-9.982c-0.164-0.328-0.501-0.541-0.873-0.541
		c-0.368,0-0.708,0.213-0.871,0.541l-4.924,9.982l-11.015,1.6c-0.365,0.055-0.669,0.309-0.783,0.662
		c-0.114,0.348-0.021,0.738,0.245,0.994l7.969,7.771l-1.882,10.965c-0.062,0.363,0.09,0.734,0.387,0.953
		c0.301,0.217,0.696,0.244,1.024,0.072l9.85-5.18l9.851,5.18c0.143,0.076,0.298,0.111,0.452,0.111c0.003,0,0.003,0,0.003,0
		c0.536,0,0.97-0.434,0.97-0.973c0-0.074-0.008-0.146-0.024-0.219l-1.871-10.91l7.968-7.771c0.266-0.256,0.36-0.646,0.249-0.994
		C52.914,29.273,52.609,29.02,52.244,28.965z M43.091,37.355c-0.229,0.223-0.334,0.543-0.28,0.857l1.635,9.533l-8.561-4.5
		c-0.281-0.146-0.619-0.146-0.904,0l-8.56,4.5l1.635-9.533c0.054-0.314-0.051-0.635-0.278-0.857l-6.925-6.75l9.568-1.393
		c0.317-0.045,0.592-0.242,0.733-0.531l4.278-8.672l4.28,8.672c0.143,0.289,0.416,0.486,0.731,0.531l9.571,1.393L43.091,37.355z"
            />
        </g>
    </svg>
);

RatingIcon.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default RatingIcon;
